import { render, staticRenderFns } from "./BtnCancelarEvento.vue?vue&type=template&id=89c6197a"
import script from "./BtnCancelarEvento.vue?vue&type=script&lang=js"
export * from "./BtnCancelarEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports